import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiGet, apiPost } from "@shared/queryHooks/api";

const getJobBoardJob = async ({ jobId, organizationSlug }) => {
  if (jobId != undefined && organizationSlug != undefined) {
    return await apiGet({ path: `/public/organizations/${organizationSlug}/jobs/${jobId}` });
  }
};

const applyForJob = async ({
  jobId,
  organizationSlug,
  application: { candidate, questionResponses, createdVia, src, source },
  recaptchaToken,
}) => {
  if (jobId != undefined && organizationSlug != undefined) {
    return await apiPost({
      path: `/public/organizations/${organizationSlug}/jobs/${jobId}/apply`,
      variables: { candidate, questionResponses, createdVia, src, source, recaptchaToken },
    });
  }
};

/* Hooks
--===================================================-- */
function useJobBoardJob({
  jobId,
  organizationSlug,
}): {
  status: any;
  data: any;
  error: any;
  isFetching: boolean;
  isLoading: boolean;
} {
  return useQuery(["jobBoardJob", jobId], () => getJobBoardJob({ jobId, organizationSlug }), {
    refetchOnWindowFocus: false,
  });
}

function useApplyForJob() {
  const queryClient = useQueryClient();
  return useMutation(applyForJob, {
    onSuccess: (data, mutationVariables) => {
      window.logger("[useJobBoard] useApplyForJob", { data, mutationVariables });
      queryClient.invalidateQueries(["jobBoardJob", mutationVariables.jobId]);
    },
    // throwOnError: true,
  });
}

export { useJobBoardJob, useApplyForJob };
